import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaImage } from "react-icons/fa";
import { request } from "../../../utils/api";
import { makeError } from "../../../utils";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../utilComponent/Loading";
import * as Yup from "yup";
import { AuthContext } from "../../../auth/AuthContext";

const getUserSchema = (isEdit) =>
  Yup.object().shape({
    name: Yup.string().required("User name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    phone: Yup.string()
      .matches(/^[0-9]{10,15}$/, "Phone number must be 10–15 digits")
      .required("Phone number is required"),
    password: isEdit
      ? Yup.string().notRequired()
      : Yup.string().required("Password is required"),
    role: Yup.string().required("Role is required"),
  });


const AddUser = () => {
  const { id } = useParams();
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [postLoading, setPostLoading] = useState(false);
  const [getLoading, setGetLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    role: "",
    password: "",
    avatar: "",
    permissions: [],
    userLimits: 1,
    warehouseLimit: 1,
    productLimit: 1,
    // warehouseLimit: {
    //   enabled: false,
    //   count: 1,
    //   warehouses: [{ productLimit: 1 }],
    // },
  });

  const inputFields = [
    {
      label: "User Name",
      name: "name",
      type: "text",
      required: true,
      placeholder: "Enter user name",
    },
    {
      label: "Email Id",
      name: "email",
      type: "email",
      required: true,
      placeholder: "Enter email id",
    },
    {
      label: "Phone Number",
      name: "phone",
      type: "tel",
      required: true,
      placeholder: "Enter phone number",
    },
    {
      label: "Password",
      name: "password",
      type: "password",
      required: true,
      placeholder: "Enter password",
    },
    {
      label: "Role",
      name: "role",
      type: "text",
      required: true,
      placeholder: "Enter role",
    },
  ];
  const isSuperAdmin = user?.role_key === "super_admin";
  const roles = [
    ...(isSuperAdmin ? [{ label: "Admin", key: "admin" }] : []),
    { label: "Member", key: "member" },
    { label: "Prep Team", key: "prep_team" },
    { label: "Tracking Team", key: "tracking_team" },
  ];

  const rolePermissions = {
    admin: [
      { label: "Add Warehouse", key: "addWarehouse" },
      { label: "Update Warehouses", key: "updateWarehouse" },
      { label: "View Warehouses", key: "viewWarehouse" },
      { label: "Delete Warehouses", key: "deleteWarehouse" },
      { label: "Add User", key: "addUser" },
      { label: "Update Users", key: "updateUser" },
      { label: "View Users", key: "viewUser" },
      { label: "Delete Users", key: "deleteUser" },
      { label: "Add Product", key: "addProduct" },
      { label: "Update Product", key: "updateProduct" },
      { label: "View Product", key: "viewProduct" },
      { label: "Delete Product", key: "deleteProduct" },
      { label: "Approve Workflow", key: "approveWorkflow" },
      { label: "Update Worflow Status", key: "updateWorkflowStatus" },
      { label: "Assign Product", key: "assignProduct" },
      { label: "View Product", key: "viewAssignProduct" },
      { label: "Set Pricing", key: "setPricing" },
      { label: "Calculation", key: "viewCalculation" },
      { label: "Tracking", key: "viewTracking" },
      { label: "View Leasure", key: "viewLeasure" },
      { label: "Add Leasure", key: "addLeasure" },
      { label: "Add Record", key: "addRecord" },
      { label: "Update Record", key: "updateRecord" },
      { label: "Add Service", key: "addService" },
      { label: "Update Service", key: "updateService" },
      { label: "View Service", key: "viewService" },
      { label: "Delete Service", key: "deleteService" },
      { label: "Add Order", key: "orderAdd" },
      { label: "View Order", key: "viewOrder" },
      { label: "Update Order", key: "updateOrder" },
      { label: "View Contact", key: "contactList" },
      { label: "View Logs", key: "viewlogs" },
      { label: "Add Hero", key: "addHero" },
      { label: "View Hero", key: "heroList" },
      { label: "View Warehouse Sheet", key: "viewWarehouseSheet" },
      { label: "Set Shipment Cost", key: "setShipmentCost" },
      { label: "Upload Label", key: "uploadLablel" },
      { label: "View Label", key: "viewLablel" },
      { label: "Add Label", key: "addLablel" },
      { label: "Add Package", key: "addPackage" },
      { label: "Package List", key: "packageList" },
    ],
    member: [
      { label: "Upload Label", key: "uploadLablel" },
      { label: "View Label", key: "viewLablel" },
      { label: "Add Label", key: "addLablel" },
      { label: "View Product QTY", key: "viewProductQTY" },
      { label: "Calculation", key: "viewCalculation" },
      { label: "Add Leasure", key: "addLeasure" },
      { label: "View Leasure", key: "viewLeasure" },
    ],
    "prep_team": [
      { label: "View Tracking", key: "viewTracking" },
      { label: "Update Tracking Status", key: "updateTrackingStatus" },
      { label: "Add Product", key: "addProduct" },
      { label: "Update Product", key: "updateProduct" },
      { label: "View Product", key: "viewProduct" },
      { label: "Delete Product", key: "deleteProduct" },
      { label: "Add Leasure", key: "addLeasure" },
      { label: "Calculation", key: "viewCalculation" },
      { label: "View Leasure", key: "viewLeasure" },
      { label: "View Warehouses", key: "viewWarehouse" },
      { label: "View Warehouse Sheet", key: "viewWarehouseSheet" },
    ],
    "tracking_team": [
      { label: "View Tracking", key: "viewTracking" },
      { label: "Update Tracking Status", key: "updateTrackingStatus" },
      { label: "Add Leasure", key: "addLeasure" },
      { label: "View Leasure", key: "viewLeasure" },

    ],
  };

  const handleInputChange = (e) => {

    const { name, value } = e.target;

    if (name === "role") {
      setFormData((prev) => ({
        ...prev,
        role: value,
        permissions: [],
      }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));

  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, avatar: e.target.files[0] }));
  };

  const handlePermissionChange = (perm) => {
    setFormData((prev) => {
      const exists = prev.permissions.some((p) => p.key === perm.key);
      return {
        ...prev,
        permissions: exists
          ? prev.permissions.filter((p) => p.key !== perm.key)
          : [...prev.permissions, perm],
      };
    });
  };

  const isPermissionExist = (key) =>
    formData.permissions.some((item) => item.key === key);

  const getFormData = () => {
    const data = new FormData();

    const updatedPermissions = formData.permissions.map((p) => {
      if (p.key === "addUser") {
        return {
          ...p,
          user_limit: formData.userLimits,
        };
      }

      if (p.key === "addWarehouse") {
        return {
          ...p,
          product_limit: formData.productLimit,
          warehouse_count: formData.warehouseLimit,
          limit_type: "total",
        };
      }

      return p;
    });
    data.append("name", formData.name);
    data.append("email", formData.email);
    data.append("phone", formData.phone);
    data.append("password", formData.password);
    data.append("role", formData.role);
    data.append("user_image", formData.avatar);
    updatedPermissions.forEach((permission, index) => {
      Object.keys(permission).forEach((key) => {
        data.append(`permissions[${index}][${key}]`, permission[key]);
      });
    });
    // data.append("user_limit", JSON.stringify(formData.userLimits));
    // data.append("wearhouse_limit", JSON.stringify(formData.warehouseLimit));
    return data;
  };

  const postUser = async () => {
    try {
      setPostLoading(true);

      const schema = getUserSchema(!!id);
      await schema.validate(formData, { abortEarly: false });
      setErrors({});

      if (id) {
        await updateUser();
      } else {
        await addUser();
      }
    } catch (validationError) {
      if (validationError.inner) {
        const formErrors = {};
        validationError.inner.forEach((err) => {
          formErrors[err.path] = err.message;
        });
        setErrors(formErrors);
      }
      setPostLoading(false);
    }
  };

  const addUser = async () => {
    try {
      await request({
        url: "users",
        method: "POST",
        data: getFormData(),
      });
      toast.success("User Added Successfully.", { autoClose: 3000 });
      navigate('/user-list');
    } catch (error) {
      makeError(error, toast);
    } finally {
      setPostLoading(false);
    }
  };

  const updateUser = async () => {
    try {
      await request({
        url: `users/${id}`,
        method: "POST",
        data: getFormData(),
      });
      toast.success("User Updated Successfully.", { autoClose: 3000 });
      navigate('/user-list');
    } catch (error) {
      makeError(error, toast);
    } finally {
      setPostLoading(false);
    }
  };

  const getUser = async () => {
    try {
      setGetLoading(true);
      const response = await request({ url: `users/${id}`, method: "GET" });
      const user = response.data;

      let productLimit = 1;
      let warehouseLimit = 1;
      let userLimits = 1;

      user.permissions?.forEach((perm) => {
        if (perm.key === "addWarehouse") {
          productLimit = perm.product_limit ?? 1;
          warehouseLimit = perm.warehouse_count ?? 1;
        }

        if (perm.key === "addUser") {
          userLimits = perm.user_limit ?? 1;
        }
      });

      setFormData({
        name: user.name || "",
        email: user.email || "",
        phone: user.phone || "",
        role: user.role || "",
        password: "",
        avatar: user.user_image || "",
        permissions: user.permissions || [],
        productLimit,
        warehouseLimit,
        userLimits,
      });
    } catch (error) {
      makeError(error, toast);
    } finally {
      setGetLoading(false);
    }
  };


  useEffect(() => {
    if (id) getUser();
  }, [id]);

  const cancelAddUser = () => {
    if (id) {
      navigate("/user-list");
    } else {
      setFormData({
        name: "",
        email: "",
        phone: "",
        role: "",
        password: "",
        avatar: "",
        permissions: [],
        userLimits: 1,
        warehouseLimit: 1,
        productLimit: 1,
        // warehouseLimit: {
        //   enabled: false,
        //   count: 1,
        //   warehouses: [{ productLimit: 1 }],
        // },
      });
      setErrors({});
    }
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="container-fluid p-0">
        <div className="page-toolbar px-xl-4 px-sm-2 px-0 py-3">
          <div className="container-fluid">
            <div className="row g-3 mb-3 align-items-center">
              <div className="col">
                <ol className="breadcrumb bg-transparent mb-0">
                  <li className="breadcrumb-item">
                    <Link className="text-secondary" to="/hrms">
                      Home
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <span className="text-secondary">User</span>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Add
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <div className="page-body px-xl-4 px-sm-2 px-0 py-lg-2 py-1 mt-0 mt-lg-3">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h6 className="card-title m-0">
                      {id ? "Update User" : "Add New User"}
                    </h6>
                  </div>

                  {getLoading ? (
                    <Loading />
                  ) : (
                    <>
                      <div className="card-body">
                        <div className="row g-3">
                          {inputFields.map((field) => (
                            <div
                              className="col-lg-6 col-md-6 col-sm-12"
                              key={field.name}
                            >
                              <label className="form-label fw-semibold">
                                {field.label}{" "}
                                {field.required && (
                                  <span className="text-danger">*</span>
                                )}
                              </label>

                              <div className="input-group focus-effect">
                                {field.name === "role" ? (
                                  <select
                                    name="role"
                                    className="form-select border-start-0 focus-effect"
                                    value={formData.role}
                                    onChange={handleInputChange}
                                  >
                                    <option value="">Select role</option>
                                    {roles.map((r) => (
                                      <option key={r.key} value={r.key}>
                                        {r.label}
                                      </option>
                                    ))}
                                  </select>
                                ) : (
                                  <input
                                    type={field.type}
                                    name={field.name}
                                    className="form-control border-start-0 focus-effect"
                                    placeholder={field.placeholder}
                                    value={formData[field.name]}
                                    onChange={handleInputChange}
                                  />
                                )}
                              </div>

                              {errors[field.name] && (
                                <div
                                  className="text-danger mx-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  {errors[field.name]}
                                </div>
                              )}
                            </div>
                          ))}

                          <div className="col-12">
                            <label className="form-label fw-semibold">
                              Select Avatar
                            </label>
                            <div className="input-group focus-effect">
                              <span className="input-group-text bg-transparent border-end-0">
                                <FaImage className="text-muted" />
                              </span>
                              <input
                                type="file"
                                className="form-control border-start-0 focus-effect"
                                onChange={handleFileChange}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {formData.role && (
                        <div className="card-body">
                          <h6 className="fw-semibold mb-2">Permissions</h6>
                          <hr />
                          <div className="row g-3">
                            {rolePermissions[formData.role]?.map((perm) => (
                              <div
                                className="col-lg-3 col-md-6 col-sm-12"
                                key={perm.key}
                              >
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={perm.key}
                                    checked={isPermissionExist(perm.key)}
                                    onChange={() =>
                                      handlePermissionChange(perm)
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={perm.key}
                                  >
                                    {perm.label}
                                  </label>
                                </div>

                                {perm.key === "addWarehouse" &&
                                  isPermissionExist("addWarehouse") && (
                                    // <LimitInputGroup
                                    //   title="Warehouse Limits"
                                    //   countLabel="How many warehouses?"
                                    //   secondaryTitle="Add Product limit"
                                    //   limitState={{
                                    //     count: formData.warehouseLimit.count,
                                    //     items:
                                    //       formData.warehouseLimit.warehouses,
                                    //   }}
                                    //   itemFields={[
                                    //     { key: "productLimit", type: "input" },
                                    //   ]}
                                    //   onCountChange={(newCount) =>
                                    //     setFormData((prev) => ({
                                    //       ...prev,
                                    //       warehouseLimit: {
                                    //         count: newCount,
                                    //         warehouses: Array.from({
                                    //           length: newCount,
                                    //         }).map(() => ({
                                    //           productLimit: "",
                                    //           productLimitType: "total",
                                    //         })),
                                    //       },
                                    //     }))
                                    //   }
                                    //   onItemChange={(index, key, value) =>
                                    //     setFormData((prev) => {
                                    //       const updated = [
                                    //         ...prev.warehouseLimit.warehouses,
                                    //       ];
                                    //       updated[index][key] = value;
                                    //       return {
                                    //         ...prev,
                                    //         warehouseLimit: {
                                    //           ...prev.warehouseLimit,
                                    //           warehouses: updated,
                                    //         },
                                    //       };
                                    //     })
                                    //   }
                                    // />
                                    <>
                                      <div className="mt-2">
                                        <label className="form-label fw-semibold">
                                          Product Limit
                                        </label>
                                        <input
                                          type="number"
                                          min={1}
                                          name="productLimit"
                                          className="form-control border-start-0 focus-effect"
                                          placeholder="Enter product limit"
                                          value={formData.productLimit}
                                          onChange={(e) =>
                                            setFormData((prev) => ({
                                              ...prev,
                                              productLimit: Number(
                                                e.target.value
                                              ),
                                            }))
                                          }
                                        />
                                      </div>
                                      <div className="mt-2">
                                        <label className="form-label fw-semibold">
                                          Warehouse Limit
                                        </label>
                                        <input
                                          type="number"
                                          min={1}
                                          name="warehouseLimit"
                                          className="form-control border-start-0 focus-effect"
                                          placeholder="Enter warehouse limit"
                                          value={formData.warehouseLimit}
                                          onChange={(e) =>
                                            setFormData((prev) => ({
                                              ...prev,
                                              warehouseLimit: Number(
                                                e.target.value
                                              ),
                                            }))
                                          }
                                        />
                                      </div>
                                    </>
                                  )}

                                {perm.key === "addUser" &&
                                  isPermissionExist("addUser") && (
                                    <div className="mt-2">
                                      <label className="form-label fw-semibold">
                                        User Limit
                                      </label>
                                      <input
                                        type="number"
                                        min={1}
                                        name="userLimits"
                                        className="form-control border-start-0 focus-effect"
                                        placeholder="Enter user limit"
                                        value={formData.userLimits}
                                        onChange={(e) =>
                                          setFormData((prev) => ({
                                            ...prev,
                                            userLimits: Number(e.target.value),
                                          }))
                                        }
                                      />
                                    </div>
                                  )}
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      <div className="card-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={cancelAddUser}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary ms-3"
                          onClick={postUser}
                          disabled={postLoading}
                        >
                          {id ? "Update User" : "Add User"}{" "}
                          {postLoading && "..."}
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <style jsx>{`
          .form-control:focus,
          .form-select:focus {
            box-shadow: none;
            background-color: var(--card-color);
            border-color: #e9e6e1;
            color: var(--primary-color);
          }
          .form-control:hover {
            border-color: #e9e6e1;
          }
          .form-label {
            font-size: 15px !important;
          }
        `}</style>
      </div>
    </>
  );
};

export default AddUser;
